export const getLang = () => {
    if (localStorage) {
        let lang = localStorage.getItem('lang') || 'ru'
        if (lang == '"CN"') {
            lang = 'en'
        }
        return lang.toString().toLocaleLowerCase().replaceAll(`"`, '')
    }
    return `ru`
}
